import { formatDate } from 'utils/helpers/date'
import ActionCellRenderer from './actionCellRenderer'
import {
  ColDef,
  ICellRendererParams,
  ValueFormatterParams,
} from '@ag-grid-community/core'
import * as yup from 'yup'
import { createStoreSchema } from 'utils/schema/storeSchema'

// type LastMileObj = {
//   _id: string
//   aggregatorName: string
// }

// export type StoreFtpConfigFormData = yup.InferType<typeof storeFtpConfigSchema>

export type StoreFormData = yup.InferType<typeof createStoreSchema>
// export type StoreFormData = {
//   storeName: string
//   storeId: string
//   invoicePrefixCode: string
//   talabatId?: string
//   instashopIdentifier?: string
//   oosThreshold: string
//   lastMile: Record<string, LastMileObj[]>
//   cluster?: string
//   directPostingFieldMap?: string
//   location?: {
//     coordinates?: string
//   }
//   isPharmacyStore?: boolean
//   ftp: StoreFtpConfigFormData
// }

export enum LastMiles {
  loginext = 'Loginext',
  aggregatorLM = 'Aggregator LM',
  pickerDelivery = 'Picker Delivery',
  instashopLastmile = 'Instashop Lastmile',
}

/**
 ** LAST MILES
 */
export const LAST_MILES = Object.values(LastMiles)

export enum OrderErpSource {
  DEFAULT = 'default',
  SAP = 'sap',
}

export const storeFormFields = {
  STORE_NAME: { key: 'storeName', label: 'Store Name' },
  STORE_ID: { key: 'storeId', label: 'Store ID' },
  STORE_IS_ACTIVE: { key: 'isActive', label: 'Active' },
  STORE_INSTASHOP_IDENTIFIER: {
    key: 'instashopIdentifier',
    label: 'Instashop Identifier',
  },
  STORE_LAST_MILE: {
    key: 'lastMile',
    label: 'Order Last Mile',
  },
  ORDER_ERP_SOURCE: {
    key: 'orderErpSource',
    label: 'Order ERP Source',
  },
  STORE_TALABAT_ID: { key: 'talabatId', label: 'Talabat Id' },
  STORE_FLOWER_TALABAT_ID: {
    key: 'flowerTalabatId',
    label: 'Flower Talabat Id',
  },
  STORE_FOOD_TALABAT_ID: {
    key: 'foodTalabatId',
    label: 'Food Talabat Id',
  },
  STORE_OOS_THRESHOLD: { key: 'oosThreshold', label: 'OOS Threshold' },
  STORE_INVOICE_PREFIX_CODE: {
    key: 'invoicePrefixCode',
    label: 'Invoice Prefix Code',
  },
  STORE_CLUSTER: {
    key: 'cluster',
    label: 'Store Cluster',
  },
  DIRECT_POSTING_STORE: {
    key: 'directPostingFieldMap',
    label: 'Map to Store (Direct Posting)',
  },
  STORE_COORDINATES: {
    key: 'location.coordinates',
    label: 'Coordinates (lat, lng)',
  },
  SAP_STORE_CODE: {
    key: 'sapStoreCode',
    label: 'SAP Store Code',
  },
  STORE_EMIRATE: {
    key: 'emirate',
    label: 'Emirate',
  },
  STORE_INVOICE_ADDRESS: {
    key: 'invoiceAddress',
    label: 'Invoice Address',
  },
  STORE_INVOICE_LOGO: {
    key: 'invoiceLogo',
    label: 'Invoice Logo',
  },
  STORE_LOGINEXT_TOKEN: {
    key: 'loginextToken',
    label: 'Loginext Token',
  },
  STORE_INVOICE_SUB_LOGO: {
    key: 'invoiceSubLogo',
    label: 'Invoice Sub-Logo',
  },
  STORE_AUTO_ALLOCATE: {
    key: 'autoAllocateFl',
    label: 'Store Auto Allocate Loginext Sync',
  },
  STORE_IS_THIRD_PARTY: {
    key: 'isThirdPartyStore',
    label: 'Third Party Store',
  },
  OTP_PHONE_NUMBERS: {
    key: 'otpPhoneNumbers',
    label: 'OTP Phone Numbers',
  },
} as const

export const getColumns = (
  isEditor: boolean,
  getStoreToDelete: (params: ICellRendererParams) => void,
) =>
  [
    {
      headerName: storeFormFields.STORE_NAME.label,
      field: storeFormFields.STORE_NAME.key,
      minWidth: 200,
    },
    { headerName: 'ID', field: '_id', minWidth: 120 },
    {
      headerName: storeFormFields.STORE_TALABAT_ID.label,
      field: storeFormFields.STORE_TALABAT_ID.key,
      valueFormatter: (params: ValueFormatterParams) =>
        params.value ? params.value : '-',
    },
    {
      headerName: storeFormFields.STORE_OOS_THRESHOLD.label,
      field: storeFormFields.STORE_OOS_THRESHOLD.key,
      valueFormatter: (params: ValueFormatterParams) =>
        params.value ? params.value : '-',
    },
    { headerName: 'User', field: 'userName' },
    {
      headerName: 'Creation Date',
      field: 'createdAt',
      valueFormatter: (params: ValueFormatterParams) =>
        formatDate(params.value, { includeTime: true }),
    },
    {
      headerName: 'Status',
      field: 'isActive',
      cellRenderer: (params: ICellRendererParams) => {
        return params?.value === true
          ? 'Active'
          : params?.value === false
            ? 'Inactive'
            : '-'
      },
    },
    {
      hide: !isEditor,
      headerName: 'Action',
      field: 'save',
      minWidth: 200,
      cellRenderer: (params: ICellRendererParams) => (
        <ActionCellRenderer
          params={params}
          isEditor={isEditor}
          getStoreToDelete={getStoreToDelete}
        />
      ),
    },
    {
      headerName: storeFormFields.STORE_CLUSTER.label,
      field: storeFormFields.STORE_CLUSTER.key,
      minWidth: 150,
      valueFormatter: (params: ValueFormatterParams) =>
        params.value ? params.value : '-',
    },
    {
      headerName: storeFormFields.STORE_IS_THIRD_PARTY.label,
      field: storeFormFields.STORE_IS_THIRD_PARTY.key,
      minWidth: 150,
      cellRenderer: (params: ICellRendererParams) => {
        return params?.value === true
          ? 'Yes'
          : params?.value === false
            ? 'No'
            : '-'
      },
    },
  ] as ColDef[]
